import React from "react";
import TechNavbar from "../components/TechNavbar";
import Footer from "../components/Footer";
import FadeInSection from "../components/FadeInSection";
import SoftwareDevelopmentHeroSection from "../components/SoftwareDevelopment/SoftwareDevelopmentHeroSection";
import WebDevelopmentSection from "../components/SoftwareDevelopment/WebDevelopmentSection";
import MobileAppSection from "../components/SoftwareDevelopment/MobileAppSection";
import DatabaseSection from "../components/SoftwareDevelopment/DatabaseSection";
import EnterpriseSection from "../components/SoftwareDevelopment/EnterpriseSection";

const SoftwareDevelopment = () => {
  return (
    <div className="min-h-screen">
      {/* Navigation Bar  */}
      <TechNavbar />

      {/* Hero Section */}
      <FadeInSection>
        <SoftwareDevelopmentHeroSection />
      </FadeInSection>

      {/* WEB DEVELOPMENT SECTOION */}
      <FadeInSection>
        <WebDevelopmentSection />
      </FadeInSection>

      {/* MOBILE APPLICATION DEVELOPMENT SECTION */}
      <FadeInSection>
        <MobileAppSection />
      </FadeInSection>

      {/* DATABASE SECTIONS  */}

      <FadeInSection>
        <DatabaseSection />
      </FadeInSection>
      {/* DATABASE SECTION 2 */}

      <FadeInSection>
        <EnterpriseSection />
      </FadeInSection>

      <Footer />
    </div>
  );
};

export default SoftwareDevelopment;
